import * as Immutable from "immutable";

const UserMap = Immutable.OrderedMap;

export default UserMap;
